import { render, staticRenderFns } from "./tigerFaq.vue?vue&type=template&id=535157d6"
import script from "./tigerFaq.vue?vue&type=script&lang=js"
export * from "./tigerFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports